import { DataBean } from "../DataBean";

export class SpareInventoried extends DataBean {

  public async getSpareInventoriedCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getSpareInventoriedCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteSpareInventoried(idspareinventoried: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteSpareInventoried_Number", [idspareinventoried]);
  }

  public async updateSpareInventoried(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.SpareInventoried_updateSpareInventoried_com.orange.finance.processcontract.bean.SpareInventoried",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.SpareInventoried",
        },
      ]
    );
  }
}
